import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography, DatePicker } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";
import dayjs from 'dayjs';

const { Option } = Select;
const { Title } = Typography;

const ElectricalServiceDamageForm = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [serviceOutageTypes, setServiceOutageTypes] = useState([]);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/electrical/enums/service-outages")
      .then(({ data }) => {
        setServiceOutageTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        lossOfService: props.record.damage.lossOfService,
        affectedUsers: props.record.damage.affectedUsers,
        electricalOutage: props.record.damage.electricalOutage,
        geometry: props.record.damage.geometry,
        startDate: props.record.damage.startDate ? dayjs(props.record.damage.startDate) : null,
        endDate: props.record.damage.endDate ? dayjs(props.record.damage.endDate) : null,
      });
    }
  }, [props.record.damage, form]);

  // Handle form field changes
  const onValuesChange = (changedValues, allValues) => {
    const newDamage = { ...props.record };
    newDamage.damage.lossOfService = elvis(allValues.lossOfService);
    newDamage.damage.startDate = elvis(allValues.startDate);
    newDamage.damage.endDate = elvis(allValues.endDate);
    newDamage.damage.affectedUsers = elvis(allValues.affectedUsers);
    newDamage.damage.electricalOutage = elvis(allValues.electricalOutage);
    newDamage.damage.geometry = elvis(allValues.geometry);
    
    // Check if form is valid
    form.validateFields()
      .then(() => {
        newDamage.valid = true;
        props.parentCallback(newDamage);
      })
      .catch(() => {
        newDamage.valid = false;
        props.parentCallback(newDamage);
      });
  };

  return (
    <Form 
      form={form}
      layout="horizontal"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      className="details_form"
      onValuesChange={onValuesChange}
      name="electricalServiceDamageForm"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Network Service"
      />
      <Form.Item label="Start Date" name="startDate">
        <DatePicker />
      </Form.Item>
      <Form.Item label="End Date" name="endDate">
        <DatePicker />
      </Form.Item>
      <Form.Item label="Loss of service (%)" name="lossOfService">
        <InputNumber />
      </Form.Item>
      <Form.Item label="Affected Users" name="affectedUsers">
        <InputNumber />
      </Form.Item>
      <Form.Item
        label="Type of outage"
        name="electricalOutage"
        tooltip="Type of outage"
      >
        <Select>
          {serviceOutageTypes.map(name => (
            <Option key={name} value={name}>
              {t('electricalEnums.serviceOutage.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Affected Area" name="geometry">
        <Map2 name="affected_area"></Map2>
      </Form.Item>
    </Form>
  );
};

export default ElectricalServiceDamageForm;